export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20golden%20and%20amber%20light%20rays%20emerging%20from%20darkness%2C%20theater%20spotlight%20effect%2C%20rich%20textured%20atmosphere%2C%20elegant%20film%20noir%20aesthetic%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20artistic%20composition%20suitable%20for%20movie%20streaming%20website%2C%20no%20text%20no%20people%2C%20luxurious%20cinema%20vibe&width=1600&height=900&seq=hero-cinema-bg&orientation=landscape"
          alt="90影院背景"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50/90"></div>

      <div className="relative z-10 w-full mx-auto max-w-[1440px] px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/15 text-accent-400 text-xs md:text-sm font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1.5"></i>每日更新 · 不缓冲 · 高清画质
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-4">
              90影院 — 8090后的免费高清影视乐园
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mb-6 font-heading">
              海量片源，即点即看，拒绝等待
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              90影院汇聚全网热门电影、电视剧、综艺、动漫资源，采用智能CDN加速与多重备用线路，确保高清画质下流畅不卡顿。每日同步最新热播内容，涵盖动作、喜剧、悬疑、科幻、爱情、古装等全题材，无需注册会员，打开即可免费畅享不间断的观影体验。当前热播频道已上线多部高分院线大片与口碑剧集，精彩永不停更。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-8 mb-8">
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-primary-500">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">影片资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-primary-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">每日更新</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl font-bold text-primary-500">1080P</div>
                <div className="text-xs text-foreground-500 mt-1">全高清画质</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>开始观影
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 border border-secondary-300 text-foreground-700 hover:text-foreground-950 hover:border-secondary-400 font-medium text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-newspaper-line mr-2"></i>了解最新动态
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-300/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20poster%20collage%20featuring%20abstract%20film%20elements%2C%20warm%20golden%20and%20amber%20color%20tones%2C%20dramatic%20lighting%2C%20film%20reel%20and%20clapperboard%20silhouettes%2C%20elegant%20movie%20themed%20illustration%20with%20rich%20textures%2C%20dark%20background%20with%20glowing%20highlights%2C%20artistic%20composition%2C%20no%20visible%20text%2C%20luxurious%20cinema%20atmosphere&width=800&height=1000&seq=hero-cinema-visual&orientation=portrait"
                  alt="90影院 — 免费高清影视平台"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-100 rounded-xl px-4 py-3 border border-background-200/60">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                    <i className="ri-flashlight-line text-accent-400 text-sm"></i>
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-foreground-800 whitespace-nowrap">极速不缓冲</div>
                    <div className="text-xs text-foreground-500">多重线路智能切换</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}